import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { RegistrationDialogBoxComponent } from '../registration-dialog-box/registration-dialog-box.component';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { environment } from 'src/environments/environment';
import { RegnExamDataComponent } from '../regn-exam-data/regn-exam-data.component';
import { RegnExamSubComponent } from '../regn-exam-sub/regn-exam-sub.component';
import { DatePipe } from '@angular/common';
import { StudentDetailsComponent } from '../student-details/student-details.component';
import { Router } from '@angular/router';
import { Location } from '@angular/common';

@Component({
  selector: 'app-scrutiny-report',
  templateUrl: './scrutiny-report.component.html',
  styleUrls: ['./scrutiny-report.component.scss']
})
export class ScrutinyReportComponent implements OnInit { 
  SearchRegnForm: FormGroup;
  APIService: string;
  courseList: any;
  filteredcourseList: any;
  SessionFilterList: any;
  sessionList: any;
  filteredCollegeList: any;
  collegeList: any;
  dialogRef: MatDialogRef<any>;
  filteredSrtyList: any;
  SrtyList: any;
  GridData: any;
  Table = false;
  selectedRow: any | null = null;
  constructor(
    public umsService: UmsService,
    private spinner: NgxSpinnerService,
    private httpClient: HttpClient,
    private modalPopupService: ModalpopService,
    public fb: FormBuilder,
    public datepipe: DatePipe,    private location: Location,
    private dialog: MatDialog,public router: Router
  ) { this.APIService = environment.serviceUrl; }

  ngOnInit(): void {
    this.SearchRegnForm = this.fb.group({
      Status: new FormControl(''),
      SnNo: new FormControl(''),
      CgCode: new FormControl(''),
      CoCode: new FormControl(''),
    })

    this.getCourseData();
    this.fetchSession();
 
    this.fetchSrty();
  }

  
  fetchSrty() {
    this.spinner.show();
    const payload = {};
    payload['CdType'] = 'SRTY';
    this.umsService.getCode(payload).subscribe((res) => {
      if (res.status) {
        this.spinner.hide();
        this.SrtyList = res.data;
        this.filteredSrtyList = this.SrtyList.slice();
      } else {
        this.spinner.hide();
      }
    }, (ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      // let data = {};
      // data['message'] = ERROR.error.message;
      // data['title'] = 'Alert';
      // data['icon'] = 'fas fa-close';
      // this.dialogRef1 = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }


  getCourseData() {
    this.spinner.show();
    const payload = {};
    this.umsService.getCourse(payload).subscribe(res => {
      this.spinner.hide();
      this.courseList = res.data;
      this.filteredcourseList = this.courseList.slice();
      // this.getCollegeData();
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
      this.courseList = [];
      // let data = {}
      // data['message'] = ERROR.error.message
      // data['title'] = 'Information'
      // data['icon'] = 'fas fa-close'
      // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
  }

  fetchSession() {
    const payload = {};
    payload['SnDefault'] = '';
    payload['SnNo'] = ''; 
    this.umsService.getSession(payload).subscribe(res => {
      this.sessionList = [];
      if (res.status) {
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
    })
  }

  getCollegeData(CoCode) {
    this.spinner.show();
    const payload = {};
    payload['CoCode'] = CoCode;
    this.umsService.courseClg(payload).subscribe((res) => {
      this.spinner.hide();
      this.collegeList = res.data;
      this.filteredCollegeList = this.collegeList.slice();
    
    },(ERROR: HttpErrorResponse) => {
      this.collegeList = [];
      this.spinner.hide();
    })
  }
  Back(){
    this.goBack();
   }
   goBack(): void {
    this.location.back(); // This will navigate back to the previous page
  }

  reset(){
    this.SearchRegnForm.reset();
    this.Table = false
  }

  getData(){
    this.GridData = []
    this.Table = false
    this.spinner.show();
    const payload = {};
    payload['CgCode'] = this.SearchRegnForm.value.CgCode;
    payload['CoCode'] = this.SearchRegnForm.value.CoCode;
    payload['SnNo'] = this.SearchRegnForm.value.SnNo;
    payload['Status'] =this.SearchRegnForm.value.Status;
      this.umsService.SearchScrutinyReport(payload).subscribe((res) => {
        if(res.status){
          this.spinner.hide();
          this.Table = true;
          this.GridData = res.data
        }
        else{
          this.spinner.hide();
          this.Table = false;
          this.GridData = []
        }
      
      },(ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        this.Table = false;
        this.GridData = []
      })
  }


  getstuid(){
    this.selectedRow;   
    let payload = {}
    payload['StuRgNo']= this.selectedRow.StuRgNo;
    payload['StuId']= '';
    this.umsService.getStuId(payload).subscribe((res) => {
      this.spinner.hide();
      // this.router.navigate(['student-profile'],
      // { queryParams: { 
      //   StudentId: res.data[0].StuId,
      //   from:'report',
      //   SessionId:this.selectedRow.SessionId
      // }}
      // ); 

      this.router.navigate(['student-profile'], {
        state: {
          StudentId: res.data[0].StuId,
          from: 'report',
          SessionId:this.selectedRow.SessionId
        }
      });
    },(ERROR: HttpErrorResponse) => {
      this.spinner.hide();
    })
    
  }


  selected(data){
    this.selectedRow = data;
  }

  // 504
  download(){
    var filter: any;
    const payload1 = this.SearchRegnForm.value.Status;
    let jsonString = JSON.stringify(payload1).replace(/\\/g, '');
    var filter: any; 
    filter = {
      "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
      "RptCode": 504,
      "InstName": '',
      "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
      "ShId": '',
      "CgCode": this.SearchRegnForm.value.CgCode,
      "RollNo": '',
      "Cent": '',
      "TnCode": '',
      "EsId": '',//this.emid
      "CsNo": '',
      "PgBreak": '',
      "StrId": '', //this.submitpayload['strId'] ? this.submitpayload['strId'] : 0,
      "StrCode": '',
      "RgNo": '',
      "UC": '',
      "Ledger": '',
      "RegnRoll": '',
      "DsCode": '',
      "CoCode": this.SearchRegnForm.value.CoCode,
      "SnNo": this.SearchRegnForm.value.SnNo,
      "Extra1": JSON.stringify(payload1),
    }
    var payload: any;
    payload = filter;
    this.umsService.setData(JSON.stringify(payload));
    this.redirect('reports')
  }


  redirect(to): void {
    this.router.navigate([to]);
  }
}
